var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2229 9.7309L21.3554 15.4209C21.7632 15.677 21.7632 16.2744 21.3554 16.5305L12.4315 21.9076C12.2229 22.0309 11.9668 22.0309 11.7582 21.9076L2.83431 16.5305C2.41704 16.2744 2.41704 15.6675 2.83431 15.4209L12.2229 9.7309Z",
    fill: "#0A3B87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2229 6.26941L21.3554 11.9595C21.7632 12.2155 21.7632 12.813 21.3554 13.069L12.4315 18.4461C12.2229 18.5694 11.9668 18.5694 11.7582 18.4461L2.83431 13.0785C2.41704 12.8224 2.41704 12.2155 2.83431 11.9689L12.2229 6.26941Z",
    fill: "#F28629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83431 8.57387L11.8815 3.09246C12.0901 2.96918 12.3557 2.96918 12.5643 3.09246L21.3554 8.56439C21.7632 8.82044 21.7632 9.41789 21.3554 9.67394L12.4315 15.051C12.2229 15.1743 11.9668 15.1743 11.7582 15.051L2.83431 9.69291C2.41704 9.43686 2.41704 8.82992 2.83431 8.58335V8.57387Z",
    fill: "#0A3B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.d2d5730d5fddd750dc086e9cc3ece689.svg";
export { ForwardRef as ReactComponent };